import { render } from "./UpdateMenuCategory.vue?vue&type=template&id=57c00636&scoped=true"
import script from "./UpdateMenuCategory.vue?vue&type=script&lang=js"
export * from "./UpdateMenuCategory.vue?vue&type=script&lang=js"

import "./UpdateMenuCategory.vue?vue&type=style&index=0&id=57c00636&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c00636"]])

export default __exports__